export default __webpack_public_path__ + "static/media/Pancake-Swap-Graphic.bfc5527c.png";